import { Button, Input } from 'antd';
import SaveStatusText from './SaveStatusText';
import type { AutosaveResult } from '../hooks/useAutosave';

interface Props {
  mobile: boolean;
  title: string;
  onTitleChange: (title: string) => void;
  autosave: AutosaveResult;
}

/** 捲到側欄的發佈設定卡（手機上它排在編輯器下方）。 */
function scrollToPublish() {
  document.getElementById('publish-card')?.scrollIntoView({ behavior: 'smooth' });
}

/**
 * 文章編輯頁 portal 進 header 的內容。
 * 桌機：可直接編輯的標題輸入框。
 * 手機：header 太窄 → 唯讀標題＋精簡儲存狀態＋「發佈」（捲到發佈設定卡）；標題改在頁面頂端編輯。
 */
export default function EditHeaderTitle({ mobile, title, onTitleChange, autosave }: Props) {
  if (!mobile)
    return (
      <Input
        variant="borderless"
        placeholder="文章標題…"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        className="!w-full !px-0 !text-lg !font-semibold !text-[#1f2733]"
      />
    );

  return (
    <div className="flex min-w-0 flex-1 items-center gap-2">
      <span className="min-w-0 flex-1 truncate text-[15px] font-semibold">{title || '未命名'}</span>
      <SaveStatusText autosave={autosave} compact />
      <Button type="primary" size="small" onClick={scrollToPublish}>
        發佈
      </Button>
    </div>
  );
}
